// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2217":"css/app.6928","8141":"css/admin-app.6928"}[chunkId] + ".css";
};